import React, {useState, useRef, useEffect, useMemo, Fragment} from 'react';
import Link from 'next/link';
import { v4 as uuidv4 } from 'uuid';
import {useRouter} from 'next/router';
import {UserIcon, VisDiv, DocumentPin,  Loading } from '..';
import {useStateContext} from '../../context/StateContext';
import { addValueForDropdown, userLogCheck, unique, nPostazione, euro, percentage, twoDecimals  } from '../../lib/utils'; 
import {useCreateReplace, useDeleteDocument} from '../../hooks/mutations'
import Swal from "sweetalert2"
import { IoIosAddCircleOutline } from 'react-icons/io';
import PromiseQueue from 'p-queue'
import TrueFalseToggle from '../TrueFalseToggle';
import { useExpanded, useTable, useColumnOrder } from "react-table";
import RichTextEditor from '../RichTextEditor';

import { offerTableData } from '../../lib/offerTableData';


   const CustomerProductsReport = ({data}) => {
       
      //console.log("IN CONSOLE OFFER REPORT DATA", data)

      //DATA PREPARATION ______

      const [workingData, setWorkingData] = useState([])
      const [loading, setLoading] = useState(false)


     //===========
     useEffect(()=>{
      setLoading(true)
      setWorkingData(offerTableData(data))
      setLoading(false)
  },[data])
     
     const testFunction = () => {
         console.log("data Customer Products", data)
         
     }
     const value = (cellValue, valueType) => {

      if(valueType == "PERCENTAGE") return percentage(cellValue)
      if(valueType == "CURRENCY") return euro(cellValue)
      if(valueType == "TWODECIMALS") return twoDecimals(cellValue)
      if(valueType == "RICHEDITOR") return  <RichTextEditor existingDoc={cellValue} readOnly={true}/>

      return cellValue
     }
     const hiddenColumns = ["law"]
     const values = useMemo(() => (tableData(workingData, hiddenColumns)?.data),[workingData]);

     const columns = useMemo(
       () => (tableData(workingData, hiddenColumns)?.columns),[workingData]
     );
 
     
     useEffect(()=>{
      tableData(workingData, hiddenColumns)?.hideColumns.forEach(x=>toggleHideColumn(x,true))
     },[workingData])
 
 
     const { getTableProps, getTableBodyProps, toggleHideColumn, headerGroups, rows, prepareRow } = 
     useTable({ columns, data:values });
   if(loading) return <Loading/> 
   return (
     <div className="App">
      <VisDiv rules={[true]}><button onClick={testFunction}>test offer report</button></VisDiv>
       <div className="container">
         <table {...getTableProps()}>
           <thead>
             {headerGroups.map?.((headerGroup, index) => (
               <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                 {headerGroup.headers.map?.((column, index) => {
                   const isCost = column?.isCost
                   const costsColor = isCost ? {backgroundColor:"red"} : {backgroundColor:"#385391"}
                   return (
                   <th key={index} style={{fontSize:"12px", color:"white",...costsColor }} {...column.getHeaderProps()}>
                     {column.render("Header")}
                   </th>
                 )})}
               </tr>
             ))} 
           </thead>
           <tbody {...getTableBodyProps()} style={{fontSize:"12px"}}>
             {rows.map?.((row, index) => {
               const rowColour = index % 2 ? "white":"#f3f4f3"
               prepareRow(row);

               return (
                 <Fragment key={index}>
                   <tr style={{backgroundColor: rowColour}} {...row.getRowProps()}  >
                     {row.cells.map?.((cell, index) => {
                        const valueType = cell?.column?.valueType
                      
                        const cellValue = (cell?.row?.original?.labourProduct && cell?.column?.id == "quantity") ? 1 : value(cell?.value, valueType)
                        const cellColour = () => {
                          const excludeIds = [
                            "34a1fc10-375b-4238-bd37-3a339a70243a",
                            "2b5fda99-211a-4512-b02b-085199dccbf9",
                            "d0b3f302-92ef-423b-bd9f-709c35e6dde2"
                          ]
                          const isExcluded = excludeIds?.some?.((x)=>x == cell?.row?.original?.allowZero)
                          if(cell?.row?.original?.allowZero) return ({})
                          if(+cell?.value <= 0){return ({backgroundColor:"red"})}
                          return ({})
                        }
                        const onCellClick = () => {
                          console.log("offer cell click", cell)
                        }
                       return(
                       <td onClick={onCellClick} key={index} style={{...cellColour(), borderRight: 1, borderRightColor: "#d1c5c5", borderRightStyle: "dotted"}}  {...cell.getCellProps()}> {cellValue} </td>
                     )})}
                   </tr>
                 </Fragment>
               );
             })}
           </tbody>
         </table>
       </div>
     </div>
   )
     }

export default CustomerProductsReport


export const tableData = (workingData, hiddenColumns=[]) => {
  //console.log("WORKING DATA IN TEABLE DATA", workingData)
  const tableValues = !workingData ? [] : workingData?.map?.((x)=> x?.flat().map?.((item)=>({[item?.accessor]: item?.value})).reduce(((r, c) => Object.assign(r, c)), {}))

  const uniqueTableDataArray = unique("accessor",workingData?.flat(2))
  const tableColumns = uniqueTableDataArray.map?.((item => {
    return({
      accessor: item?.accessor,
      Header: item?.Header,
      //order: item?.order,
      isCost: item?.isCost,
      minWidth: item?.minWidth,
      labourProduct: item?.labourProduct,
      valueType: item?.valueType
  })}))

  const doc = {
       columns: tableColumns,
       data: tableValues,
       hideColumns: [
        "_id",
        "allowZero",
        "labourProduct",
        "nonConformity",
        "customerProduct", 
        ...hiddenColumns],
       }
    return doc
}